module.exports = __webpack_public_path__ + "img/search.266e841e.svg";